import { SET_CURRENT_NEWS } from "./newsConstants";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import db from "../../db";
import { throwInfo } from "../../lib/error_helper";
import { MAX_NOTIF_CLOSE_NUMBER } from "../../constants";

export function setCurrentNewsAction(currentNews) {
    return {
        type: SET_CURRENT_NEWS,
        currentNews,
    };
}

export function whatSUp() {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/whatSUp", {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((news) => {
                news.forEach((n) => {
                    db.News.get({
                        notif_date: n.notif_date,
                        notif_title: n.notif_title,
                    }).then((dbNews) => {
                        if (dbNews) return;

                        n.read = false;
                        n.notifCloseCounter = 0;
                        db.News.put(n);
                    });
                });

                dispatch(loadCurrentNews());
            })
            .catch((err) => {
                console.error("Erreur : newsActions - whatSUp", err);
                //Discretion puisqu'on est forcément en synchro en arrière plan
            });
    };
}

export function showNewsNotif(currentNews) {
    return !currentNews.read && currentNews.notifCloseCounter < MAX_NOTIF_CLOSE_NUMBER;
}

export function loadCurrentNews() {
    return (dispatch) => {
        db.News.toCollection()
            .last()
            .then((lastNews) => {
                if (!lastNews) return;

                dispatch(setCurrentNewsAction(lastNews));

                if (!showNewsNotif(lastNews)) return;

                let action =
                    lastNews && lastNews.url
                        ? {
                              label: "En savoir plus",
                              callback: () => goToNews(lastNews),
                          }
                        : null;

                dispatch(
                    throwInfo({
                        position: "tc",
                        title: lastNews.notif_title,
                        message: lastNews.notif_content,
                        dismissible: true,
                        autoDismiss: 0,
                        onRemove: () => closeNews(lastNews),
                        action,
                    })
                );
            });
    };
}

export function updateNewsInDb(currentNews) {
    db.News.where({
        notif_date: currentNews.notif_date,
        notif_title: currentNews.notif_title,
    }).modify(currentNews);
}

export function closeNews(currentNews) {
    currentNews.notifCloseCounter++;
    updateNewsInDb(currentNews);
}

export function goToNews(currentNews) {
    currentNews.read = true;
    updateNewsInDb(currentNews);

    if (currentNews && currentNews.url) window.open(currentNews.url, "_blank");
}
